<template>
  <div class="base-step-form">
    <div class="base-step-form-item">
      <div class="base-step-form-title">
        <span>标签名称</span>
      </div>
      <div class="base-step-form-content">
        <el-input :value="name" placeholder="请输入标签名称" maxlength="60" @input="val => $emit('update:name', val)" />
      </div>
    </div>
    <div class="base-step-form-item is-wrap">
      <div class="base-step-form-title">
        <span>标签类型</span>
      </div>
      <div class="base-step-form-content">
        <div class="field-type-group-item" v-for="typeGroup in typeList" :key="typeGroup.key">
          <div class="field-type-group-header">
            <span>{{ typeGroup.label }}</span>
          </div>
          <div class="field-type-ul">
            <div
              class="field-type-item"
              v-for="typeItem in typeGroup.children"
              :key="typeItem.type"
              :class="typeItem.type === type && 'is-pick'"
              @click="pickHandle(typeItem)"
            >
              <div class="field-type-item-header">
                <div class="field-type-item-title">{{ typeItem.label }}</div>
              </div>
              <div class="field-type-item-tip">{{ typeItem.tip }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { services } from '@/service';
export default {
  data() {
    return {
      typeList: services.labelRelation.getEntityRelationGroup()
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  methods: {
    pickHandle(typeItem) {
      this.$emit('update:type', typeItem.type);
    }
  }
};
</script>

<style lang="scss" scoped>
.base-step-form {
  .base-step-form-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .base-step-form-title {
      width: 90px;
      font-size: 14px;
      line-height: 20px;
      color: #2c3443;
      margin-left: 20px;

      & > span {
        &::after {
          content: '*';
          color: #f62733;
        }
      }
    }
    .base-step-form-content {
      width: 100%;
      margin-right: 20px;
    }

    &.is-wrap {
      flex-wrap: wrap;

      .base-step-form-title {
        margin-bottom: 10px;
      }
      .base-step-form-content {
        margin-right: 0;
      }
    }

    .field-type-group-item {
      margin-top: 20px;

      &:first-child {
        margin-top: 0;
      }
      .field-type-group-header {
        position: relative;
        padding-left: 8px;
        margin-left: 20px;

        & > span {
          position: relative;
          font-size: 14px;
          color: #2c3443;
          line-height: 20px;
          font-weight: bold;
          background-color: #fff;
          z-index: 2;
          padding-right: 5px;
        }

        &::before {
          content: ' ';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 2px;
          height: 12px;
          background-color: #1991fb;
          border-radius: 3px;
        }

        &::after {
          content: ' ';
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translate(-25%, -50%) scale(0.5);
          width: calc(200% - 20px);
          height: 1px;
          background-color: #e8ebef;
        }
      }

      .field-type-ul {
        margin-top: 10px;
        .field-type-item {
          padding: 10px 20px;
          cursor: pointer;

          &.is-pick,
          &:hover {
            background-color: #eaf6ff;
          }

          .field-type-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .field-type-item-title {
              color: #3d465a;
              font-size: 14px;
              line-height: 20px;
            }
          }
          .field-type-item-tip {
            color: #9599a5;
            font-size: 12px;
            line-height: 18px;
            margin-top: 3px;
          }
        }
      }
    }
  }
}
</style>
